import React from 'react';
import { Popup } from 'react-leaflet';
import PivotDeviceChart from './PivotDeviceCard';
import DeviceCard from './DeviceCard';

const WIDTH = 240;
const OFFSET = [0, -7];
const TOP_LEFT_PADDING = [80, 80];
const BOTTOM_RIGHT_PADDING = [80, 80];

function DevicePopup({ device, bundle }) {
  return (
    <Popup
      minWidth={WIDTH}
      maxWidth={WIDTH}
      offset={OFFSET}
      autoPan={true}
      autoPanPaddingTopLeft={TOP_LEFT_PADDING}
      autoPanPaddingBottomRight={BOTTOM_RIGHT_PADDING}
    >
      {bundle ? <PivotDeviceChart device={device} bundle={bundle} /> : <DeviceCard device={device} />}
    </Popup>
  );
}

export default DevicePopup;
